// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ttQE","notes":"Notes_notes__wLq66","note":"Notes_note__2y641","markdown":"Notes_markdown__25HSe"};